module.exports = __webpack_public_path__ + "static/img/Parc-des-Princes-Football.ace1663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Parc-des-Princes-Football.jpg
// module id = AEFU
// module chunks = 0